import { WaterIndexModel } from "@/core/models/water-index.model";
import { WATER_INDEX_REPORT_CONFIGS } from "./water-index-report";
import { FilterInputType } from "@/app/home/components/filter/FilterBar";
import { ReportTableConfigs } from "@/app/home/components/report/ReportTable";

export const ABNORMAL_CONSUMPTION_REPORT_CONFIGS: {name: string, props: ReportTableConfigs<WaterIndexModel, null>} = {
    name: "Báo cáo Khách hàng sử dụng nước bất thường",
    props: {
        ...WATER_INDEX_REPORT_CONFIGS.props,
        filterTemplates:[
            {
                dataIndex: "search",
                label: "Tìm kiếm",
                placeholder: "Nhập nội dung tìm kiếm",
                type: FilterInputType.text,
            },
            {
                dataIndex: "month",
                label: "Tháng",
                placeholder: "Chọn tháng",
                type: FilterInputType.month,
            },
            {
                dataIndex: "tollAreaId",
                label: "Khu vực",
                placeholder: "Chọn Khu vực",
                type: FilterInputType.select,
                options: []
            },
            {
                dataIndex: "differenceRatio",
                label: "Biến động % tối thiểu",
                placeholder: "Nhập % biến động cần tra cứu",
                type: FilterInputType.number,
            },
            {
                dataIndex: "createdBy",
                label: "Người đọc",
                placeholder: "Chọn Người đọc",
                type: FilterInputType.select,
                options: []
            },
        ],
        defaultFilter: {status: "read"},
        onFilterChanged: async () => {
            return {
                filterTemplates: undefined,
            }
        },
    }
}